import api from "./base-api"

const clockmakerClansApiV2CM = api.injectEndpoints({
    endpoints: (build) => ({
        getMembershipCM: build.query({
            query: (data = "") => `v2/clockmaker/clans/members/${data}`,
            providesTags: ['ClanMembersCM']
        }),
        getChatCM: build.query({
            query: (data = "") => `v2/clockmaker/clans/chat/${data}/0`,
            providesTags: ['ClanChatCM'],
        }),
        deleteChatMessageCM: build.mutation({
            query: (body) => ({
                url: `v2/clockmaker/clans/chat/delete`,
                method: "POST",
                body,
            }),
            invalidatesTags: ['ClanChatCM'],
        }),

        kickCM: build.mutation({
            query: (data = {}) => ({
                url: `v2/clockmaker/clans/kick/${data.userId}/${data.kickId}`,
                method: "POST",
            }),
            invalidatesTags: ['ClanMembersCM'],
        }),

        joinCM: build.mutation({
            query: (data = {}) => ({
                url: `v2/clockmaker/clans/join/${data.userId}/${data.community}`,
                method: "POST",
            }),
            invalidatesTags: ['ClanMembersCM'],
        }),

        promoteCM: build.mutation({
            query: (data) => ({
                url: `v2/clockmaker/clans/promote/${data.userId}/${data.promoteId}`,
                method: "POST",
            }),
            invalidatesTags: ['ClanMembersCM'],
        }),

        setCheaterCM: build.mutation({
            query: (body = {}) => ({
                url: `v2/clockmaker/clans/cheater`,
                method: "POST",
                body: body
            }),
            invalidatesTags: ['ClanMembersCM'],
        }),
        setRenameCM: build.mutation({
            query: (body = {}) => ({
                url: `v2/clockmaker/clans/rename`,
                method: "POST",
                body: body
            }),
            invalidatesTags: ['ClanMembersCM'],
        }),
        searchClanByNameCM: build.mutation({
            query: (name) => `v2/clockmaker/clans/search-by-name?name=${encodeURIComponent(name)}`,
        }),
        setDescriptionCM: build.mutation({
            query: (body = {}) => ({
                url: `v2/clockmaker/clans/description`,
                method: "POST",
                body: body
            }),
            invalidatesTags: ['ClanMembersCM'],
        })
    }),
    overrideExisting: false
})

export const {
    useGetMembershipCMQuery,
    useGetChatCMQuery,
    useDeleteChatMessageCMMutation,
    useSetCheaterCMMutation,
    useSetRenameCMMutation,
    useSetDescriptionCMMutation,
    useKickCMMutation,
    useJoinCMMutation,
    usePromoteCMMutation,
    useSearchClanByNameCMMutation
} = clockmakerClansApiV2CM
